import Loader from "./Loader";

const TableLoader = () => {
  return (
    <div className='flex justify-center items-center py-16'>
      <Loader />
    </div>
  )
}

export default TableLoader;
